const initState = {};

const currentDoctorReducer = (state = initState, action) => {
  return state;
};

export default currentDoctorReducer;
